module.exports = __webpack_public_path__ + "static/collectorcans-escape-artwork-775720a55d09bc4b7c7892ad28667769.png";